import React, { useEffect } from 'react';
import BasicCalculations from './basic-calculations';
import SurfaceEquipment from './surface-equipment';
import WellSurvey from './well-survey';
import Tabs from '../../common/Tabs';
import GasCalculations from './gas-calculations';
import Schematics from './schematics';
import { useAppSelector } from '../../../store/hooks/StoreHooks';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

interface OutputSectionProps {
    children?: React.ReactNode;
}

const OutputSection: React.FC<OutputSectionProps> = ({ children }) => {
    const { ID, caseID } = useParams();
    const projectID = ID?.split("projectID=")?.[1] || "";
    const caseId = caseID?.split("caseID=")?.[1] || "";
    const projectId = caseId || projectID;
    
    const { fluidInput } = useAppSelector((state) => state?.jetlift?.fluid);
    const { showOutput } = useAppSelector((state) => state?.jetlift?.gasCalculations);
    const selectedProject = useAppSelector((state) => state.myProjects.selectedProject);
    const [activeTab, setActiveTab] = React.useState(0);
    const dispatch = useDispatch();

    // Well survey data loading is handled by the WellSurvey component itself

    const handleTabChange = (index: number) => {
        setActiveTab(index);
    };

    const tabs = [
        {
            label: 'Gas calculations',
            content: (
                <>{showOutput ? <GasCalculations /> : null}</>
            ),
            isDisabled: fluidInput?.gasAvailblty === '1' ? false : true,
        },
        {
            label: 'Basic calculations',
            content: (
                <>{showOutput ? <BasicCalculations /> : null}</>
            )
        },
        // {
        //     label: 'Surface equipment',
        //     content: (
        //         <>{showOutput ? <SurfaceEquipment /> : null}</>
        //     )
        // },
        // {
        //     label: 'Schematics',
        //     content: (
        //         <>{showOutput ? <Schematics /> : null}</>
        //     )
        // },
        {
            label: 'Well survey',
            content: (
                <WellSurvey />
            )
        },
    ];

    return (
        <div className="flex items-start flex-col justify-between flex-1 rounded-[8px] border-darkcolor-400 bg-darkcolor-700 border-[1px] text-neutral-25 w-full h-full" role='output-section-container'>
            {children}
            <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} className='bg-darkcolor-700 rounded-tl-lg rounded-tr-lg' />
        </div>
    );
};

export default OutputSection;